import React, { useState } from 'react'
import { FaAngleDown, FaAngleUp } from "react-icons/fa";

function Accordion() {
    const [ShowHideAccordion, SetShowHideAccordion] = useState(false);
    const [ShowHideAccordionTwo, SetShowHideAccordionTwo] = useState(false);
    const [ShowHideAccordionThree, SetShowHideAccordionThree] = useState(false);

    const onClickAccordianShowHide = () => {
        SetShowHideAccordion(!ShowHideAccordion)
    }
    const onClickAccordianShowHideTwo = () => {
        SetShowHideAccordionTwo(!ShowHideAccordionTwo)
    }
    const onClickAccordianShowHideThree = () => {
        SetShowHideAccordionThree(!ShowHideAccordionThree)
    }
    return (
        <div>
            <h6 class="mt-10"><span>RESPONSE SCHEMA:  </span>  <span style={{ color: "#313131" }}>application/x-www-form-urlencode</span></h6>
                  <hr class="hr-col" />
            <table className="sc-hHEiqL iZJLLY">
                <tbody>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_id"><span
                            className="sc-iemWCZ fhDkLh"></span><span>ag_id</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 10 </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Aggregator ID.It's value must be AvantGarde</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="me_id"><span
                            className="sc-iemWCZ fhDkLh"></span><span>me_id</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Merchant Id issued by Avantgrade</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="order_no"><span
                            className="sc-iemWCZ fhDkLh"></span><span>order_no</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>This is your Transaction ID for which you have initiated payment.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="amount"><span
                            className="sc-iemWCZ fhDkLh"></span><span>amount</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">number</span><span
                                        className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;double&gt; </span><span> <span
                                            className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>This is your Transaction Amount.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Country"><span
                            className="sc-iemWCZ fhDkLh"></span><span>Country</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span
                                        className="sc-fbIWvP sc-jOFryr JIFSj egeLzW" style={{color: 'rgb(14, 124, 134)'}}>^\d{3}$</span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>ISO Country Code.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="Currency"><span
                            className="sc-iemWCZ fhDkLh"></span><span>Currency</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span
                                        className="sc-fbIWvP sc-jOFryr JIFSj egeLzW"  style={{color: 'rgb(14, 124, 134)'}}>^\d{3}$</span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>ISO Currency Code.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_date"><span
                            className="sc-iemWCZ fhDkLh"></span><span>txn_date</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 10 characters </span></span>
                                </div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>The transaction date and must be supplied in DD-MM-YY format.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="txn_time"><span
                            className="sc-iemWCZ fhDkLh"></span><span>txn_time</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> 8 characters </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>The transaction time and must be supplied in HH:MM:SS format.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="ag_ref"><span
                            className="sc-iemWCZ fhDkLh"></span><span>ag_ref</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>This is Transaction ID generated by aggregator for which you have initiated
                                            payment.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_ref"><span
                            className="sc-iemWCZ fhDkLh"></span><span>pg_ref</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 20 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>This is Transaction ID generated by gateway for which you have initiated
                                            payment.</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="status"><span
                            className="sc-iemWCZ fhDkLh"></span><span>status</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                <div><span className="sc-fbIWvP JIFSj"> Enum:</span> <span
                                    className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Successful"</span> <span
                                        className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Failed"</span> <span
                                            className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Holding"</span> <span
                                                className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Pending"</span> </div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Transaction Status </p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_code"><span
                            className="sc-iemWCZ fhDkLh"></span><span>res_code</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 5 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Response Code. "0" for Success</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="res_message"><span
                            className="sc-iemWCZ fhDkLh"></span><span>res_message</span></td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span
                                        className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 200 ] </span></span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                        <p>Response message explaining the failure reason. "0" for Success</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr className="expanded">
                        <td className="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field"
                            title="pg_details" onClick={onClickAccordianShowHide}>
                            <span className="sc-iemWCZ fhDkLh"></span>
                            <span>pg_details {ShowHideAccordion ? <FaAngleDown/> : <FaAngleUp/>}</span>
                        </td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    {ShowHideAccordion &&
                    <tr>
                    <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                            <table id="myDIV" className='sc-hHEiqL iZJLLY'>
                                <tbody>
                                    <tr>
                                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field"
                                            title="senderKey"><span
                                                className="sc-iemWCZ fhDkLh"></span><span>senderKey</span></td>
                                        <td className="sc-bkbkJK gmOLLi">
                                            <div>
                                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span
                                                        className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;base64&gt;
                                                    </span></div>
                                                <div>
                                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                        <p>public key identifying the sender of the payload</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_id">
                                            <span className="sc-iemWCZ fhDkLh"></span><span>pg_id</span></td>
                                        <td className="sc-bkbkJK gmOLLi">
                                            <div>
                                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span
                                                        className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt;
                                                    </span><span> <span className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1
                                                        .. 3 ] </span></span></div>
                                                <div>
                                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                        <p>Bank Number. E.g. “1” for HDFC Bank</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="pg_name">
                                            <span className="sc-iemWCZ fhDkLh"></span><span>pg_name</span></td>
                                        <td className="sc-bkbkJK gmOLLi">
                                            <div>
                                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span>
                                                        <span className="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 50 ]
                                                        </span></span></div>
                                                <div>
                                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                        <p>Bank Name</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="paymode">
                                            <span className="sc-iemWCZ fhDkLh"></span><span>paymode</span></td>
                                        <td className="sc-bkbkJK gmOLLi">
                                            <div>
                                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div>
                                                <div><span className="sc-fbIWvP JIFSj"> Enum:</span> <span
                                                    className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"NB"</span> <span
                                                        className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CC"</span> <span
                                                            className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"DC"</span> <span
                                                                className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"PP"</span> <span
                                                                    className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"WA"</span> <span
                                                                        className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"CE"</span> </div>
                                                <div>
                                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                        <p>Provides details about the paymode.<br />
                                                            Valid values:<br />
                                                        </p>
                                                        <ul>
                                                            <li>NB: Net Banking</li>
                                                            <li>CC: Credit Card</li>
                                                            <li>DC: Debit Card</li>
                                                            <li>PP: Prepaid Card</li>
                                                            <li>WA: Wallet</li>
                                                            <li>CE: Credit Card EMI</li>
                                                        </ul>
                                                        <p></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr className="last undefined">
                                        <td className="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field"
                                            title="emi_months">
                                                <span class="sc-iemWCZ fhDkLh"></span>
                                            <span>emi_months</span>
                                        </td>
                                        <td className="sc-bkbkJK gmOLLi">
                                            <div>
                                                <div>
                                                    <span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                                        className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span>
                                                </div>
                                                <div><span className="sc-fbIWvP JIFSj"> Enum:</span> <span
                                                    className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"3"</span> <span
                                                        className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"6"</span> <span
                                                            className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"9"</span> <span
                                                                className="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"12"</span> </div>
                                                <div>
                                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS">
                                                        <p>Tenure of EMI (3/6/9/12).Paymode must be Credit Card EMI
                                                            (CCE).</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </td>
                    </tr>
                    
                    }
                    <tr className="expanded">
                        <td className="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field"
                            title="pg_details" onClick={onClickAccordianShowHideTwo}>
                            <span className="sc-iemWCZ fhDkLh"></span>
                            <span>fraud_details {ShowHideAccordionTwo ? <FaAngleDown/> : <FaAngleUp/>}</span>
                        </td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    {ShowHideAccordionTwo &&
                    <tr>
                    <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                        <table class="sc-hHEiqL iZJLLY"><tbody><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_action"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_action</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span></div><div><span class="sc-fbIWvP JIFSj"> Enum:</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Accept"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Reject"</span> <span class="sc-fbIWvP sc-hmbstg JIFSj eqivia col-gray">"Review"</span> </div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Provides details about the fraud action. <br/>
Only if fraud engine is selected <br/>
Valid values:<br/>
  </p><ul>
    <li>Accept: Fraud not suspected. </li>
    <li>Reject: Very strong fraud suspicion, reject the order. </li>
    <li>Review:  Fraud suspected, review the customer details before processing the order. </li>
  </ul><p></p>
</div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="fraud_message"><span class="sc-iemWCZ fhDkLh"></span><span>fraud_message</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 200 </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Fraud message describes the fraud in details.Only if fraud engine is selected.</p>
</div></div></div></td></tr><tr class="last undefined"><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="score"><span class="sc-iemWCZ fhDkLh"></span><span>score</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">integer</span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo"> &lt;int64&gt; </span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> [ 1 .. 10 ] </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>Risk scale</p>
</div></div></div></td></tr></tbody></table>
                        </div>
                    </td>
                    </tr>
                    }
                    <tr className="expanded last undefined">
                        <td className="sc-hBMUJo sc-fFSPTT sc-ckTSus dMYtew ktTSbS iILgRz" kind="field"
                            title="pg_details" onClick={onClickAccordianShowHideThree}>
                            <span className="sc-iemWCZ fhDkLh"></span>
                            <span>other_details {ShowHideAccordionThree ? <FaAngleDown/> : <FaAngleUp/>}</span>
                        </td>
                        <td className="sc-bkbkJK gmOLLi">
                            <div>
                                <div><span className="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span
                                    className="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">object</span></div>
                                <div>
                                    <div className="sc-iBzEeX sc-cOifOu coaOfs exfXOS"></div>
                                </div>
                            </div>
                        </td>
                    </tr>
                    {ShowHideAccordionThree &&
                    <tr>
                    <td colspan="2" className="sc-hBMUJo sc-fnVZcZ dMYtew hmqpxx">
                        <div className="sc-dIvrsQ kPKTxr">
                        <table class="sc-hHEiqL iZJLLY"><tbody><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf1"><span class="sc-iemWCZ fhDkLh"></span><span>udf1</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>user defined field that you can use to send any additional information about the transaction</p>
</div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf2"><span class="sc-iemWCZ fhDkLh"></span><span>udf2</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>user defined field that you can use to send any additional information about the transaction</p>
</div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf3"><span class="sc-iemWCZ fhDkLh"></span><span>udf3</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>user defined field that you can use to send any additional information about the transaction</p>
</div></div></div></td></tr><tr><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf4"><span class="sc-iemWCZ fhDkLh"></span><span>udf4</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>user defined field that you can use to send any additional information about the transaction</p>
</div></div></div></td></tr><tr class="last undefined"><td class="sc-hBMUJo sc-fFSPTT dMYtew ktTSbS" kind="field" title="udf5"><span class="sc-iemWCZ fhDkLh"></span><span>udf5</span></td><td class="sc-bkbkJK gmOLLi"><div><div><span class="sc-fbIWvP sc-FRrlG JIFSj gDAJjz"></span><span class="sc-fbIWvP sc-fXazdy JIFSj bbtMDo">string</span><span> <span class="sc-fbIWvP sc-bTDOke JIFSj jgudcY col-red"> &lt;= 100 characters </span></span></div> <div><div class="sc-iBzEeX sc-cOifOu coaOfs exfXOS"><p>user defined field that you can use to send any additional information about the transaction</p>
</div></div></div></td></tr></tbody></table>
                        </div>
                    </td>
                    </tr>
                    }
                </tbody>
            </table>
            

        </div>
    )
}

export default Accordion